import React from 'react';

const CancellationPolicy = () => (
    <div className="PrivacyInfo__description" style={{ color: '#fff' }}>
        <span className="InfoHeader">Условия отмены</span>
        <p>После того как ставка была подтверждена онлайн или по телефону, ставка считается окончательной и не подлежит изменению или отмене.</p>
        <p>У вас есть возможность сделать ставку на противоположный исход, чтобы уменьшить проигрыш, но ставка не может быть отменена. Все выплаты по ставкам рассчитываются по коэффициентам, действовавшим в момент размещения ставки. Любые последующие изменения коэффициентов не влияют на размещенные ставки.</p>
        <p>Во избежание ошибок мы настоятельно рекомендуем внимательно проверять все ставки на ваших купонах перед их подтверждением онлайн и внимательно слушать агента при размещении ставок по телефону.</p>
    </div>
);

export default CancellationPolicy; 